import classNames from "classnames";

import styles from "./ResponsiveStack.module.scss";

type ResponsiveStackProps = {
  children: React.ReactNode;
  className?: string;
  gap?: string;
} & JSX.IntrinsicElements["div"];

export function ResponsiveStack({
  children,
  className,
  gap = "16px",
  ...props
}: ResponsiveStackProps) {
  const stackClasses = classNames(styles["responsive-stack-root"], className);

  return (
	<div className={stackClasses} {...props} style={{ gap: gap }} >
	  {children}
	</div>
  );
}